import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import SurveyButton from "./button";
import { SECONDARY_COLOR } from "../../../color-constants";


const DisclaimerModal = styled.div`
  position: absolute;
  background-color: #fefefe;
  min-width: 260px;
  border: 1px solid #888;
  border-radius: 4px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 376;
  transform: translateX(calc(-100% - 15px)) translateY(calc(50% - 25px));
  cursor: default;

  @media (max-width: 800px) {
    display: none;
  }
`;

const Heading = styled.div`
  font-weight: 400;
  font-size: 18px;
  text-align: center;
  margin-bottom: 10px;
  color: ${props => props.color ? props.color : `${SECONDARY_COLOR}`};
`;

const Content = styled.div`
  background-color: #fff;
  border-radius: 4px;
  padding: 15px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  color: #626469;
`;

const Arrow = styled.div`
  position: absolute;
  right: -9px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid white;
`;

const DisclaimerBody = styled.span`
  margin-bottom: 10px;
  display: block;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: -10px;
  margin-right: -10px;
`;

const ButtonWrapper = styled.div`
  margin-bottom: 10px;
  margin-right: 10px;
`;

class SurveyDisclaimer extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    textColor: PropTypes.string,
    onOpen: PropTypes.func,
    onDismiss: PropTypes.func,
    getLabel: PropTypes.func,
  };

  render = () => {
    return (
      <DisclaimerModal>
        <Content>
          <Arrow />
          <Heading color={this.props.color}>
            {this.props.getLabel(
              "survey.disclaimer.title"
            )}
          </Heading>
          <DisclaimerBody>{this.props.getLabel("survey.disclaimer.content")}</DisclaimerBody>
          <ButtonsWrapper>
            <ButtonWrapper>
              <SurveyButton text={this.props.getLabel('survey.disclaimer.later')} color={this.props.color} textColor={this.props.textColor} outline={true} callback={this.props.onDismiss}></SurveyButton>
            </ButtonWrapper>
            <ButtonWrapper>
              <SurveyButton text={this.props.getLabel('survey.disclaimer.start')} color={this.props.color} textColor={this.props.textColor} callback={this.props.onOpen}></SurveyButton>
            </ButtonWrapper>
          </ButtonsWrapper>

        </Content>
      </DisclaimerModal>
    );
  };
}

export default SurveyDisclaimer;
